module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('header-show'), _vm._v(" "), _c('news-section'), _vm._v(" "), _c('hb-huizhan', {
    attrs: {
      "time": _vm.huizhan_a.time,
      "dataName": _vm.huizhan_a.file
    }
  }), _vm._v(" "), _c('hb-huizhan', {
    attrs: {
      "time": _vm.huizhan_b.time,
      "dataName": _vm.huizhan_b.file
    }
  }), _vm._v(" "), _c('hb-hotel', {
    attrs: {
      "setTitle": _vm.hotel_a.title,
      "dataName": _vm.hotel_a.file,
      "pagePath": _vm.hotel_a.page,
      "isShow": _vm.hotel_a.isShow
    }
  }), _vm._v(" "), _c('hb-hotel', {
    attrs: {
      "setTitle": _vm.hotel_b.title,
      "dataName": _vm.hotel_b.file,
      "pagePath": _vm.hotel_b.page,
      "isShow": _vm.hotel_b.isShow
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f55c8a16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Home.vue
// module id = 188
// module chunks = 1